import { useSelector } from "react-redux";
import { useMatches } from "react-router-dom";
import App from "../components/App";
import Login from "../components/Login";
import { selectLoggedInUser } from "../redux/auth";

const Root = () => {
  const loggedInUser = useSelector(selectLoggedInUser);
  const matches = useMatches();
  const breadcrumbs = matches
    .filter((m) => m.handle?.crumb)
    .map((m) => m.handle.crumb());
  const searchable = matches.some((m) => m.handle?.searchable);
  return loggedInUser ? (
    <App breadcrumbs={breadcrumbs} searchable={searchable} />
  ) : (
    <Login />
  );
};

export default Root;
